// extracted by mini-css-extract-plugin
export default {"hr-line":"About_hr-line__6mcIn","img-border":"About_img-border__XO59P","custom-card":"About_custom-card__HQefh","text-justify":"About_text-justify__u+6fw"};